<article class="sim-video">
  <div class="container">
    <div class="row align-items-center position-relative">
      <!-- <div
        class="col-sm-12"
        style="position: absolute; z-index: 1; margin-top: 120px"
      >
        <div
          class="simmer-animation play-btn-simmer sim-circle-btn text-center font-24"
          style="
            height: 90px;
            width: 90px;
            margin: 0 auto 80px;
            line-height: 90px;
          "
        >
          <span class="icon-play-button ml-0"></span>
        </div>
      </div> -->
      <div class="col-sm-12">
        <div
          class="simmer-animation sim-heading"
          style="height: 20px; max-width: 400px"
        ></div>
        <div class="simmer-animation sim-date w-75"></div>
        <div class="simmer-animation sim-date mt-3" style="width: 15%"></div>
        <div class="d-flex align-items-start mt-4">
          <div
            class="simmer-animation mini-btn mr-2"
            style="height: 40px; width: 150px; border-radius: 25px"
          ></div>
          <div class="simmer-animation sim-circle-btn mini-btn mr-2"></div>
          <div class="simmer-animation sim-circle-btn mini-btn mr-2"></div>
          <div class="simmer-animation sim-circle-btn mini-btn mr-2"></div>
          <div class="simmer-animation sim-circle-btn mini-btn mr-2"></div>
        </div>
      </div>
      <div class="related-search sim-gallery my-3 col-8">
        <div
          class="container-fluid"
          style="padding: 10px !important;"
        >
          <div class="row m-0">
            <div
              class="simmer-animation circle"
              style="width: 50px; height: 50px"
            ></div>
            <div class="w-75 ml-4">
              <div
                class="simmer-animation simmer-name mb-1"
                style="max-width: 400px; height: 16px"
              ></div>
              <div
                class="simmer-animation simmer-rating mb-2"
                style="width: 35px; height: 18px"
              ></div>
              <div
                class="simmer-animation simmer-desc"
                style="width: 100%; height: 21px"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</article>
<div class="mob-sim-poster">
  <article class="sim-video pb-4">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-sm-12">
          <div
            class="simmer-animation play-btn-simmer sim-circle-btn text-center font-24"
            style="
              height: 90px;
              width: 90px;
              margin: 0 auto 80px;
              line-height: 90px;
            "
          >
            <span class="icon-play-button ml-0"></span>
          </div>
        </div>
      </div>
    </div>
  </article>
  <div class="col-sm-12">
    <div
      class="simmer-animation sim-heading"
      style="height: 20px; max-width: 400px"
    ></div>
    <div class="simmer-animation sim-date w-75"></div>
    <div class="simmer-animation sim-date mt-3" style="width: 15%"></div>
    <div class="d-flex align-items-start mt-4">
      <div
        class="simmer-animation mini-btn mr-2"
        style="height: 40px; width: 150px; border-radius: 25px"
      ></div>
      <div class="simmer-animation sim-circle-btn mini-btn mr-2"></div>
      <div class="simmer-animation sim-circle-btn mini-btn mr-2"></div>
      <div class="simmer-animation sim-circle-btn mini-btn mr-2"></div>
      <div class="simmer-animation sim-circle-btn mini-btn mr-2"></div>
    </div>
  </div>
  <div class="related-search sim-gallery my-3 col-12 col-md-8">
    <div
      class="container-fluid"
      style="padding: 10px !important;"
    >
      <div class="row m-0">
        <div
          class="simmer-animation circle"
          style="width: 50px; height: 50px"
        ></div>
        <div class="w-75 ml-4">
          <div
            class="simmer-animation simmer-name mb-1"
            style="max-width: 400px; height: 16px"
          ></div>
          <div
            class="simmer-animation simmer-rating mb-2"
            style="width: 35px; height: 18px"
          ></div>
          <div
            class="simmer-animation simmer-desc"
            style="width: 100%; height: 21px"
          ></div>
        </div>
      </div>
    </div>
  </div>
</div>
